import styled from 'styled-components'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { Heading1 } from '@chegg-wt/core/theme/sunkist/typography'
import { HeadingReset } from '@chegg-wt/core/theme/sunkist/resets'

import { themeBreakPoints } from '@chegg-wt/core/theme/theme'
import OriginalListSelector from './ListSelector'

export const Title = styled.h1`
  ${HeadingReset};
  ${Heading1};
`

export const ListSelector = styled(OriginalListSelector)``

/**
 * [1]: min-width is necessary here to change how flex determine's its auto flex-basis value
 */
export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  & > * {
    max-width: 100%;
  }

  & > * + * {
    margin-top: ${values.xsmall};
  }

  @media (min-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    & > * {
      flex: 0 0 auto;
    }

    & > ${ListSelector} {
      flex: 0 1 auto;
      min-width: 0; /* [1] */
    }

    & > * + * {
      margin-left: ${values.base};
      margin-top: 0;
    }
  }
`

export const Header = styled.div`
  & > * + * {
    margin-top: ${values.base};
  }
`
